//sbensouda: please do not change production value!!!!
// const baseURL = (process.env.NODE_ENV == "development") ? "http://localhost:3001" : "http://api.afrijula.gm" ;
// const baseURL = (process.env.NODE_ENV == "development") ? "http://10.255.9.87:3000" : "http://10.255.9.44:3000"; //Bak's machine
const baseURL = "https://api.lecket.gm";
// const baseURL = "http://localhost:3000";
export default baseURL;


